import RtlPreviewModel      from './models/rtl_preview';
import TitleCard            from '../media/TitleCard';
import TitleCollection      from '../media/models/TitleCollection';
import TitleCollectionView  from '../media/TitleCollectionView';
import FacetsController     from '../../pages/facets/facets_controller';
import PatronTitleStatus from '../../models/PatronTitleStatus';

export default class RtlPreviewCollection extends Backbone.View {

    className = 'RTLRecommendations';

    loaderTemplate = _.template(`
        <div class="loader">
            <%= html('loading') %>...
        </div>`);

    template = _.template(`
        <div class="u-hr"></div>

        <a href="javascript:void(0)" data-facet="recommend-to-library" class="seeAllButton u-pullRight u-allCaps">
            <%= html('seeAll') %>
        </a>

        <h2 tabindex="-1" class="title"><%= html('rtlRecommendations.didntFind') %></h2>
        <p class="subTitle">
            <%= html('rtlRecommendations.weCanAddTitle') %>
        </p>

        <ul class="titleContainer" style="margin: 0px;"></ul>`);

    // patronMediaItemsModel
    constructor({bus, el, featureManager}) {
        super();

        this.bus        = bus;
        this.model      = new RtlPreviewModel();
        this.collection = new TitleCollection();
        this.facetsController = new FacetsController();


        this.setElement(el);
        this.$el.empty().html(this.loaderTemplate());

        if (featureManager.isEnabled('rtl-preview') && featureManager.isEnabled('recommend-to-library')) {
            this.bus.on('search:render', () => {
                const waypoint = new window.Waypoint.Inview({
                    element: this.$el,
                    enter: () => {
                        waypoint.destroy();
                        this._update();
                    }
                });
            });
        } else {
            this.$el.empty();
        }
    }

    _update() {
        this.model.fetch()
            .then((titles) => {
                // Remove the control completely if there were no results returned
                if (_(titles).isEmpty()) {
                    this.$el.empty();
                    return;
                }

                let patronTitleStatus = new PatronTitleStatus();
                patronTitleStatus.fetchTitleStatus(titles).then(() => {
                    patronTitleStatus.updateTitleCollectionState(this.collection);
                });

                this.collection.reset(titles);
                this.render();
            })
            .fail(() => {
                this.$el.empty();
            });
    }

    render() {
        this.$el.empty().html(this.template());

        const facetsController = this.facetsController;

        this.$('.seeAllButton').on('click', function() {
            facetsController.select(this); // eslint-disable-line no-invalid-this
        });

        this.titleCollectionView = new TitleCollectionView({
            el: this.$('.titleContainer'),
            bus: this.bus,
            View: TitleCard,
            attributes: {class: 'titleContainer small-block-grid-2 medium-block-grid-4 large-block-grid-4'},
            collection: this.collection,
            coverWidths: {mobile: 215, tablet: 220, desktop: 220}
        });
    }
}
